/**
 * Styles given input elements as premium locked feature.
 * @param {Object} options
 *
 */
let universalModal = function(options) {

    let _defaults = {
        linkAttribute: 'data-container-modal',
        modalClassAttribute: 'data-modal-class',
        modalId: 'container-modal',
        errorMessage: 'Error occurred during opening modal, please try again'
    };

    let widget = this;

    widget.options =  $.extend({}, _defaults, options || {});
    widget.modal = $('<div>')
        .addClass('reveal')
        .attr('id', widget.options.modalId)
        .attr('data-reveal', true)
        .attr('data-close-on-click', true);

    widget.opened = false;
    widget.waitingForResponse = false;

    let element = widget.modal.get(0);

    // make the widget accessible from the HTML element itself
    element.universalModalWidget = widget;

    let body = $('body');
    body.append(widget.modal);

    new Foundation.Reveal(widget.modal);

    widget.modal.on('closed.zf.reveal', function() {
        widget.opened = false;
    });

    widget.modal.on('open.zf.reveal', function() {
        widget.opened = true;
    });

    body.on('click', '[' + widget.options.linkAttribute + ']', function(e) {
        e.preventDefault();
        let target = $(this);
        if (target.attr('disabled'))
            return;
        let handleForms = target.data('handle-form') !== undefined;
        let modalClass = target.closest('a[' + widget.options.linkAttribute + ']').attr(widget.options.modalClassAttribute);
        let href = target.attr('href');
        MyAngelcam.Log.info('Opening container modal', {
            href: href,
            handleForm: handleForms
        });
        widget.modal.addClass(modalClass);
        widget.open($(this).attr('href'), handleForms);
    });

    // open modals automatically if the current location hash matches the modal link ID
    $(window).on('hashchange', function() {
        widget._openByHash(window.location.hash);
    });
    widget._openByHash(window.location.hash);
};

universalModal.prototype.open = function(url, handleForms) {
    this._makeInitialRequest(url, handleForms);
};

universalModal.prototype._openByHash = function(hash) {
    if (hash.startsWith('#')) {
        hash = hash.substring(1);
    }

    if (hash !== '') {
        $(`#${hash}[${this.options.linkAttribute}]`).trigger('click');
    }
};

universalModal.prototype._closeBtn = function() {
    return '<button class="close-button" data-close aria-label="Close modal" type="button">' +
        '<span aria-hidden="true"><i class="fa fa-times"></i></span>' +
    '</button>';
};

universalModal.prototype._makeInitialRequest = function(url, handleForm) {
    let widget = this;
    $.ajax(url).done(resp => {
        widget._fillContentOfModal(resp, handleForm);
    }).fail(() => {
        MyAngelcam.messagesModule.showMessage('error', widget.options.errorMessage);
    });
};

universalModal.prototype._fillContentOfModal = function(resp, handleForm) {
    let widget = this;
    resp += widget._closeBtn();
    let content = $('<div>').html(resp);
    widget.modal.html(content);
    if (!widget.opened) {
        widget.modal.foundation('open');
    }
    content.foundation();

    if (handleForm) {
        widget._handleForm(content.find('form'), handleForm);
    }
};

universalModal.prototype._handleForm = function(form, handleForm) {
    let widget = this;
    form.submit(function(e){
        e.preventDefault();
        if (widget.waitingForResponse) {
            return; // don't allow to resubmit form when request in process
        }
        widget.waitingForResponse = true;
        $.post(form.attr('action'), form.serialize()).done(function(data, textStatus, xhr) {
            if (xhr.getResponseHeader('X-Modal-Form') !== 'validation:valid') {
                widget._fillContentOfModal(xhr.responseText, handleForm);
            } else if (data.close_on_success) {
                widget.modal.foundation('close');
            } else if (data.success_in_modal) {
                widget.open(data.success_url, handleForm);
            } else {
                window.location = data.success_url;
            }
        }).always(() => {
            widget.waitingForResponse = false;
        });
    });
};

module.exports = universalModal;



// WEBPACK FOOTER //
// ./src/resources/js/universalModal.js